export default "__VITE_ASSET__BO0JouIn__"